(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-v3-customer-proof"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eg-customer-proof')) {
  customElements.define('eg-customer-proof', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      if (window.Trustpilot?.loadFromElement) this.querySelectorAll('.trustpilot-widget').forEach(trustbox => window.Trustpilot.loadFromElement(trustbox, true));
      const native = this.querySelector('[data-proof-native]');
      const fallback = this.querySelector('[data-proof-fallback]');
      if (!native || !fallback) return;
      this.controller = new AbortController();
      const refresh = () => {
        const ready = [...native.querySelectorAll('img')].some(image => image.complete && image.naturalWidth >= 80 && image.getBoundingClientRect().width >= 80 && image.getBoundingClientRect().height >= 80);
        fallback.hidden = ready;
      };
      native.addEventListener('load', refresh, { capture: true, signal: this.controller.signal });
      native.addEventListener('error', refresh, { capture: true, signal: this.controller.signal });
      window.addEventListener('resize', refresh, { signal: this.controller.signal });
      this.observer = new MutationObserver(refresh);
      this.observer.observe(native, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class', 'style', 'hidden'] });
      refresh();
    }
    disconnectedCallback() { this.cleanup(); }
    cleanup() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-v3-equipment-details"] && !Shopify.designMode) return;
  try {
    
// Long descriptions open as a preview on phones so reviews are not pushed far down the page.
if (!customElements.get('eg-read-more')) {
  customElements.define('eg-read-more', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.copy = this.querySelector('.eg3-detail-copy');
      this.toggle = this.querySelector('.eg3-readmore-toggle');
      if (!this.copy || !this.toggle) return;
      this.ready = true;
      this.phone = window.matchMedia('(max-width: 749px)');
      this.toggle.addEventListener('click', () => this.setExpanded(this.toggle.getAttribute('aria-expanded') !== 'true', true));
      this.phone.addEventListener?.('change', () => this.apply());
      this.apply();
    }
    apply() {
      // Only collapse when it saves a meaningful amount of scrolling.
      const long = this.phone.matches && this.copy.scrollHeight > 520;
      this.toggle.hidden = !long;
      if (long) this.setExpanded(this.toggle.getAttribute('aria-expanded') === 'true');
      else this.classList.remove('is-clamped');
    }
    setExpanded(expanded, byUser = false) {
      this.classList.toggle('is-clamped', !expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.textContent = expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
      if (byUser && !expanded) this.scrollIntoView?.({ block: 'nearest' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-v3-equipment-main"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eg-equipment')) {
  customElements.define('eg-equipment', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.config = JSON.parse(this.querySelector('[data-equipment-config]').textContent);
      this.productForm = this.querySelector('product-form');
      this.form = this.productForm.querySelector('form');
      this.variantInput = this.form.querySelector('[name="id"]');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.querySelectorAll('[data-enhanced]').forEach(node => { node.hidden = false; });
      this.initGalleryGestures(options);
      this.variantInput.addEventListener('change', () => this.selectVariant(true, true), options);
      this.optionSelects = [...this.querySelectorAll('[data-equipment-option]')];
      if (this.optionSelects.length) {
        this.querySelector('[data-equipment-variant-field]').hidden = true;
        this.optionSelects.forEach(select => select.addEventListener('change', () => this.chooseOption(select), options));
      }
      this.quantity.addEventListener('input', () => this.update(), options);
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-equipment-thumb]');
        if (thumb) this.showMedia(thumb.dataset.equipmentThumb);
        const mediaStep = event.target.closest('[data-equipment-media-step]');
        if (mediaStep) this.stepMedia(Number(mediaStep.dataset.equipmentMediaStep));
        const jump = event.target.closest('[data-equipment-bulk-jump]');
        const bulk = jump && this.querySelector('.eg3-bulk');
        if (bulk) {
          event.preventDefault();
          bulk.open = true;
          bulk.scrollIntoView?.({ behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          bulk.querySelector('summary').focus({ preventScroll: true });
        }
        const step = event.target.closest('[data-equipment-step]');
        if (!step || this.productForm.classList.contains('m-spinner-loading')) return;
        const rule = this.rules();
        const current = Number(this.quantity.value) || rule.min;
        this.quantity.value = Math.max(rule.min, current + Number(step.dataset.equipmentStep) * rule.step);
        this.update();
      }, options);
      this.form.addEventListener('submit', event => {
        if (event.target !== this.form) return;
        this.limitNotice = this.config.onePerVariant && this.variant?.cartQuantity >= 1 ? this.variant.id : null;
        this.update();
        if (this.limitNotice) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        if (!this.validQuantity() || !this.variant?.available || this.productForm.classList.contains('m-spinner-loading')) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (!this.validQuantity()) this.quantity.reportValidity();
        }
      }, { ...options, capture: true });
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.productForm, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('product-ajax:added', () => this.refreshCart(), options);
      document.addEventListener('cart:updated', event => this.onCartUpdate(event.detail), options);
      ['cart-loaded', 'cart-updated'].forEach(type => window.addEventListener(`aftersell-upcart:public-events:${type}`, event => this.applyCart(event.detail?.cart?.items), options));
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        if (this.config.variants.some(variant => String(variant.id) === id)) { this.variantInput.value = id; this.selectVariant(false, true); }
      }, options);
      this.selectVariant(false, false);
      this.observeBuybox();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); this.buyboxObserver?.disconnect(); document.documentElement.classList.remove('egv3-sticky-bar'); }
    observeBuybox() {
      const bar = this.querySelector('[data-equipment-bar]');
      if (!bar || !('IntersectionObserver' in window)) { if (bar) bar.hidden = true; return; }
      bar.hidden = true;
      this.buyboxObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        bar.hidden = entry.isIntersecting;
        document.documentElement.classList.toggle('egv3-sticky-bar', !bar.hidden && getComputedStyle(bar).display !== 'none');
      });
      this.buyboxObserver.observe(this.submitButton);
    }
    chooseOption(changed) {
      const index = Number(changed.dataset.equipmentOption);
      const wanted = this.optionSelects.map(select => select.value);
      const offered = variant => variant.options.slice(0, index + 1).every((value, i) => value === wanted[i]);
      let match = this.config.variants.find(variant => variant.options.every((value, i) => value === wanted[i]));
      const note = this.querySelector('[data-equipment-option-note]');
      note.textContent = '';
      if (!match) {
        // Later options fall back to the first combination offered with the new choice.
        match = this.config.variants.find(variant => offered(variant) && variant.available) || this.config.variants.find(offered);
        if (!match) return;
        const moved = match.options.findIndex((value, i) => i > index && value !== wanted[i]);
        if (moved > -1) note.textContent = this.label('option_changed', { option: this.optionSelects[moved].labels[0]?.textContent.trim() || '', value: match.options[moved], previous: wanted[moved] });
      }
      this.variantInput.value = String(match.id);
      this.selectVariant(true, true);
    }
    syncOptions() {
      if (!this.optionSelects?.length || !this.variant) return;
      this.optionSelects.forEach((select, index) => {
        select.value = this.variant.options[index];
        [...select.options].forEach(option => {
          const candidates = this.config.variants.filter(variant => variant.options[index] === option.value && variant.options.slice(0, index).every((value, i) => value === this.variant.options[i]));
          option.disabled = candidates.length === 0;
          option.textContent = candidates.length === 0 ? `${option.value} — ${this.label('option_unavailable')}` : candidates.some(variant => variant.available) ? option.value : `${option.value} — ${this.label('sold_out')}`;
        });
      });
    }
    label(key, values = {}) { return Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`{${name}}`, String(value)), this.config.labels[key] || key); }
    money(cents) { return new Intl.NumberFormat(this.config.locale || 'en-GB', { style: 'currency', currency: this.config.currency || 'GBP' }).format(cents / 100); }
    rules() {
      const v = this.variant, min = Number(v?.rules?.min) || 1, step = Number(v?.rules?.increment) || 1;
      const caps = [v?.rules?.max, v?.inventory].filter(value => value !== null && value !== undefined).map(value => Math.max(0, Number(value) - (v.cartQuantity || 0)));
      const max = caps.length ? Math.min(...caps) : null, cart = v?.cartQuantity || 0;
      const stock = v?.inventory === null || v?.inventory === undefined ? null : Math.max(0, Number(v.inventory) - cart);
      return { min, step, max, stock, cart, stockLimited: stock !== null && max === stock };
    }
    quantityMessage() {
      const rule = this.rules(), n = Number(this.quantity.value);
      if (rule.stockLimited && rule.max >= rule.min && n > rule.max) this.contactPrompt = 'stock';
      if (rule.max !== null && rule.max < rule.min) return this.label('no_stock_quantity');
      if (rule.stockLimited && n > rule.max) return this.label(rule.cart > 0 ? 'stock_limit_cart' : 'stock_limit', { count: this.variant.inventory, cart: rule.cart, max: rule.stock });
      if (rule.step === 1) return this.label(rule.max === null ? 'quantity_minimum' : 'quantity_range', rule);
      return this.label(rule.max === null ? 'quantity_no_max' : 'quantity_invalid', rule);
    }
    validQuantity() { const n = Number(this.quantity.value), { min, max, step } = this.rules(); return this.quantity.value.trim() !== '' && Number.isSafeInteger(n) && n >= min && (max === null || n <= max) && (n - min) % step === 0; }
    selectVariant(updateUrl, adjustQuantity) {
      this.variant = this.config.variants.find(variant => String(variant.id) === this.variantInput.value);
      const rule = this.rules(); this.quantity.min = rule.min; this.quantity.step = rule.step;
      if (rule.max === null || rule.max < rule.min) this.quantity.removeAttribute('max'); else this.quantity.max = rule.max;
      if (adjustQuantity && !this.validQuantity()) this.quantity.value = rule.min;
      const mediaId = this.variant?.mediaId || this.config.fallbackMediaId;
      if (mediaId) this.showMedia(String(mediaId));
      this.syncOptions();
      this.querySelectorAll('[data-equipment-selection]').forEach(node => { node.textContent = this.variant?.title || ''; });
      document.querySelectorAll(`[data-equipment-product="${this.config.productId}"] [data-equipment-spec]`).forEach(node => {
        const value = node.dataset.equipmentSpec === 'sku' ? this.variant?.sku : this.variant?.title;
        node.textContent = value || '—';
        if (node.dataset.equipmentSpec === 'sku') node.closest('[data-equipment-sku-row]')?.toggleAttribute('hidden', !value);
      });
      if (updateUrl && this.config.updateUrl && this.variant) { const url = new URL(location.href); url.searchParams.set('variant', this.variant.id); history.replaceState(history.state, '', url); }
      this.update();
    }
    update() {
      const v = this.variant, rule = this.rules(), valid = this.validQuantity(), n = Number(this.quantity.value);
      const quantityInvalid = Boolean(v?.available) && !valid;
      const limited = Boolean(v) && this.limitNotice === v.id && v.cartQuantity >= 1;
      const soldOut = Boolean(v) && !v.available;
      this.contactPrompt = soldOut && !limited ? 'back' : null;
      // Reaching the stock limit (the + button stops) explains why, before the customer types a bigger number.
      const atStockLimit = !limited && !soldOut && !this.config.onePerVariant && valid && rule.stockLimited && rule.max >= rule.min && n === rule.max;
      if (atStockLimit) this.contactPrompt = 'stock';
      const message = limited ? this.label('one_per_order') : soldOut ? this.label('sold_out_message') : atStockLimit ? this.label(rule.cart > 0 ? 'stock_limit_cart' : 'stock_limit', { count: v.inventory, cart: rule.cart, max: rule.stock }) : !quantityInvalid ? '' : this.quantityMessage();
      this.quantity.setCustomValidity(limited || !quantityInvalid ? '' : message); this.quantity.setAttribute('aria-invalid', String(quantityInvalid));
      const error = this.querySelector('[data-equipment-error]'); error.textContent = message;
      // Contact line on its own line; the link opens the Commslayer chat (eg-v3-purchase-trust), with the contact page as the fallback.
      if (this.contactPrompt && this.config.contactUrl) { const link = document.createElement('a'); link.href = this.config.contactUrl; link.dataset.openChat = ''; link.textContent = this.label(`${this.contactPrompt}_contact`); const [before, after = ''] = this.label(`${this.contactPrompt}_prompt`).split('{link}'); const more = document.createElement('span'); more.className = 'eg3-error-more'; more.append(` ${before}`, link, after); error.append(more); }
      let price = v?.price || 0;
      if (valid) [...(v?.breaks || [])].sort((a,b) => a.minimum_quantity - b.minimum_quantity).forEach(tier => { if (n + (v.cartQuantity || 0) >= tier.minimum_quantity) price = tier.price; });
      const compare = v?.compareAtPrice > v?.price ? v.compareAtPrice : v?.price > price ? v.price : 0;
      this.querySelector('[data-equipment-price]').textContent = v ? this.money(price) : '—';
      const business = this.querySelector('[data-equipment-business-price]');
      if (business) {
        const exVat = Math.round(price / 1.2);
        business.textContent = v ? this.label('business_price', { ex: this.money(exVat) }) : '';
      }
      this.querySelector('[data-equipment-compare-wrap]').hidden = !compare;
      this.querySelector('[data-equipment-compare]').textContent = compare ? this.money(compare) : '';
      this.querySelector('[data-equipment-total]').textContent = valid && v ? this.money(price * n) : '—';
      this.querySelector('[data-equipment-price-break]').hidden = !(v && price < v.price);
      const available = Boolean(v?.available && (rule.max === null || rule.max >= rule.min));
      const stock = this.querySelector('[data-equipment-stock]');
      const remaining = v?.inventory === null || v?.inventory === undefined ? null : Math.max(0, v.inventory - (v.cartQuantity || 0));
      const low = available && v.inStock && this.config.lowStockAt > 0 && remaining !== null && remaining <= this.config.lowStockAt;
      const stockState = !available ? 'sold_out' : low ? 'low' : v.inStock ? 'in_stock' : 'available';
      stock.textContent = low ? this.label('low_stock', { count: remaining }) : this.label(stockState);
      stock.dataset.available = String(available);
      stock.dataset.stockState = stockState;
      const busy = this.productForm.classList.contains('m-spinner-loading');
      this.submitButton.disabled = !valid || !v?.available || busy;
      this.querySelector('[data-equipment-submit]').textContent = this.label(busy ? 'adding' : v?.available ? 'add' : 'sold_out');
      const estimate = this.querySelector('eg-delivery-estimate');
      if (estimate) Object.assign(estimate.dataset, { weight: String(valid ? (v?.weight || 0) * n : 0), total: String(valid && v ? price * n : 0), available: String(Boolean(valid && v?.available)), inStock: String(Boolean(v?.inStock)) });
      const barTotal = this.querySelector('[data-equipment-bar-total]');
      if (barTotal) {
        barTotal.textContent = valid && v ? this.money(price * n) : '—';
        if (this.config.variants.length > 1) this.querySelector('[data-equipment-bar-selection]').textContent = v?.title || '';
        const barAdd = this.querySelector('[data-equipment-bar-add]');
        if (barAdd) {
          barAdd.disabled = this.submitButton.disabled;
          barAdd.querySelector('[data-equipment-bar-label]').textContent = this.querySelector('[data-equipment-submit]').textContent;
        }
      }
      this.querySelector('[data-equipment-step="-1"]').disabled = busy || n <= rule.min;
      this.querySelector('[data-equipment-step="1"]').disabled = busy || !v?.available || (rule.max !== null && n + rule.step > rule.max);
    }
    showMedia(id) {
      const panels = [...this.querySelectorAll('[data-equipment-panel]')];
      if (!panels.some(panel => panel.dataset.equipmentPanel === id)) return;
      panels.forEach(panel => { panel.hidden = panel.dataset.equipmentPanel !== id; if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause()); });
      this.querySelectorAll('[data-equipment-thumb]').forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb.dataset.equipmentThumb === id)); });
      // Keep the chosen thumbnail in view without moving the page.
      const active = this.querySelector('[data-equipment-thumb][aria-pressed="true"]');
      const strip = active?.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        const thumbBox = active.getBoundingClientRect(), stripBox = strip.getBoundingClientRect();
        strip.scrollLeft += thumbBox.left - stripBox.left - (stripBox.width - thumbBox.width) / 2;
      }
    }
    stepMedia(direction) {
      const panels = [...this.querySelectorAll('[data-equipment-panel]')];
      if (panels.length < 2) return;
      const current = Math.max(0, panels.findIndex(panel => !panel.hidden));
      this.showMedia(panels[(current + direction + panels.length) % panels.length].dataset.equipmentPanel);
    }
    // Arrow keys on the gallery controls, and a sideways swipe on the image.
    initGalleryGestures(options) {
      const gallery = this.querySelector('.eg3-gallery');
      const stage = gallery?.querySelector('.eg3-stage');
      if (!stage) return;
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const onThumb = event.target.closest('[data-equipment-thumb]');
        if (!onThumb && !event.target.closest('[data-equipment-media-step]')) return;
        event.preventDefault();
        this.stepMedia(event.key === 'ArrowRight' ? 1 : -1);
        if (onThumb) this.querySelector('[data-equipment-thumb][aria-pressed="true"]')?.focus();
      }, options);
      let start = null;
      stage.addEventListener('touchstart', event => {
        start = event.touches.length === 1 && !event.target.closest('video, iframe, model-viewer') ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { ...options, passive: true });
      stage.addEventListener('touchend', event => {
        if (!start) return;
        const x = event.changedTouches[0].clientX - start.x, y = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y) * 1.5) this.stepMedia(x < 0 ? 1 : -1);
      }, { ...options, passive: true });
    }
    onCartUpdate(payload) {
      const cart = payload?.cart || payload;
      if (Array.isArray(cart?.items) && Number.isFinite(cart.item_count)) this.applyCart(cart.items);
      else if (!cart?.sections || (!cart.id && !Array.isArray(cart.items))) this.refreshCart();
    }
    applyCart(items) {
      if (!Array.isArray(items)) return;
      this.cartRevision = (this.cartRevision || 0) + 1;
      this.config.variants.forEach(variant => { variant.cartQuantity = items.filter(item => Number(item.variant_id || item.variantId) === variant.id).reduce((sum,item) => sum + item.quantity,0); });
      this.selectVariant(false, false);
    }
    async refreshCart() {
      const revision = this.cartRevision || 0;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, signal: this.controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (revision === (this.cartRevision || 0) && this.isConnected) this.applyCart(cart.items);
      } catch (error) { if (error.name !== 'AbortError') console.warn('Shopify will check equipment availability when adding to the basket.'); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-v3-product-addons"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eg-product-addons')) {
  customElements.define('eg-product-addons', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.unsubscribeCart?.();
      this.unsubscribeCart = null;
      this.cancelCartRequest();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('submit', event => {
        const wrapper = event.target.closest('[data-addon-variant]');
        if (wrapper?.classList.contains('m-spinner-loading') || wrapper?.querySelector('[name="add"]')?.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal });
      document.addEventListener('product-ajax:added', event => {
        const result = event.detail?.product;
        const ids = (result?.items || [result]).map(item => String(item?.variant_id || item?.id));
        this.querySelectorAll('[data-addon-variant]').forEach(form => {
          if (ids.includes(form.dataset.addonVariant)) this.setInBasket(form, true);
        });
        if (this.cartRequest) this.refreshCart();
      }, { signal });
      document.addEventListener('cart:updated', event => this.onCartUpdate(event.detail), { signal });
      ['cart-loaded', 'cart-updated'].forEach(type => window.addEventListener(`aftersell-upcart:public-events:${type}`, event => this.applyCart(event.detail?.cart), { signal }));
      const topic = window.MinimogTheme?.pubSubEvents?.cartUpdate;
      if (topic && window.MinimogEvents?.subscribe) {
        this.unsubscribeCart = window.MinimogEvents.subscribe(topic, payload => this.onCartUpdate(payload));
      }
      document.addEventListener('flooring:change', event => this.applyThickness(event.detail?.thickness), { signal });
      window.addEventListener('focus', () => this.refreshCart(), { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') this.refreshCart();
      }, { signal });
    }
    applyThickness(thickness) {
      const size = parseFloat(thickness);
      if (!Number.isFinite(size)) return;
      let shown = 0;
      this.querySelectorAll('[data-addon-card]').forEach(card => {
        const minimum = Number(card.dataset.addonMinThickness) || 0;
        card.hidden = size < minimum || shown >= 2;
        if (!card.hidden) shown += 1;
        const source = card.querySelector('[data-addon-thickness-variants]');
        if (!source) return;
        let match = null;
        try { match = JSON.parse(source.textContent)[thickness] || null; } catch (error) { match = null; }
        card.querySelectorAll('a[href]').forEach(link => { link.href = match?.url || card.dataset.addonUrl; });
        card.querySelector('[data-addon-price-value]').textContent = match?.price || card.dataset.addonPrice;
        const from = card.querySelector('[data-addon-from]');
        if (from) from.hidden = Boolean(match);
        const label = card.querySelector('[data-addon-thickness-label]');
        if (label) { label.textContent = match ? thickness : ''; label.hidden = !match; }
      });
    }
    setInBasket(form, present) {
      const button = form.querySelector('[name="add"]');
      button.textContent = present ? this.dataset.addedLabel : button.dataset.addonAddLabel;
      button.setAttribute('aria-label', present ? this.dataset.addedLabel : button.dataset.addonAddAria);
      button.disabled = present;
    }
    onCartUpdate(payload) {
      const cart = payload?.cart || payload;
      if (Array.isArray(cart?.items) && Number.isFinite(cart.item_count)) this.applyCart(cart);
      else if (!cart?.sections || (!cart.id && !Array.isArray(cart.items))) this.refreshCart();
    }
    applyCart(cart) {
      if (!Array.isArray(cart?.items)) return;
      this.cancelCartRequest();
      const ids = new Set(cart.items.filter(item => item.quantity > 0).map(item => String(item.variant_id || item.variantId || item.id)));
      this.querySelectorAll('[data-addon-variant]').forEach(form => this.setInBasket(form, ids.has(form.dataset.addonVariant)));
    }
    cancelCartRequest() {
      this.cartRequest?.abort();
      this.cartRequest = null;
    }
    async refreshCart() {
      this.cancelCartRequest();
      const request = new AbortController();
      this.cartRequest = request;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, signal: request.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (this.cartRequest === request && this.isConnected) this.applyCart(cart);
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('The add-on basket state will refresh after the next cart update.');
      } finally {
        if (this.cartRequest === request) this.cartRequest = null;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribeCart?.();
      this.unsubscribeCart = null;
      this.cancelCartRequest();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-flooring-choice"]) return;
  try {
    
if (!customElements.get('flooring-choice')) {
  customElements.define('flooring-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const config = this.querySelector('[data-flooring-config]');
      if (!config) return;
      this.config = JSON.parse(config.textContent);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form');
      this.variantInput = this.form.querySelector('[name="id"]');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.productForm = this.querySelector('product-form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.variant = this.config.variants.find(v => v.id === this.config.selectedId) || this.config.variants[0];
      if (!this.variant) return;
      this.selection = [...this.variant.options];
      this.gallery = 'studio';
      this.querySelectorAll('[data-enhanced]').forEach(el => el.hidden = false);
      this.initGalleryGestures(options);
      this.querySelector('[data-fallback]').hidden = true;
      this.querySelectorAll('[data-area], [data-waste]').forEach(input => input.setAttribute('form', ''));
      this.addEventListener('change', event => {
        const group = event.target.closest('[data-option-index]');
        if (group) {
          this.selection[Number(group.dataset.optionIndex)] = event.target.value;
          this.selectVariant(true);
        }
      }, options);
      this.addEventListener('delivery-estimate:basket', () => this.updateTotals(), options);
      this.addEventListener('input', event => {
        if (event.target === this.quantity) this.updateTotals();
        if (event.target.matches('[data-area], [data-waste]')) this.updateArea();
      }, options);
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-quantity-step]');
        if (step) {
          const rules = this.rules();
          const value = Number(this.quantity.value);
          this.quantity.value = Math.max(rules.min, (Number.isFinite(value) ? value : rules.min) + Number(step.dataset.quantityStep) * rules.step);
          this.updateTotals();
        }
        const thumbnail = event.target.closest('[data-gallery]');
        if (thumbnail) { this.gallery = thumbnail.dataset.gallery; this.updateGallery(); }
        const galleryStep = event.target.closest('[data-gallery-step]');
        if (galleryStep) this.stepGallery(Number(galleryStep.dataset.galleryStep));
        const guide = event.target.closest('[data-guide]');
        if (guide && !guide.disabled) {
          if (guide.dataset.guideUrl) { location.assign(guide.dataset.guideUrl); return; }
          this.selection[this.config.thicknessIndex] = guide.dataset.guide;
          this.selectVariant(true);
        }
        if (event.target.closest('[data-apply-area]')) {
          const result = this.areaEstimate();
          if (result) {
            const { min, step } = this.rules();
            this.quantity.value = min + Math.max(0, Math.ceil((result.tiles - min) / step)) * step;
            this.updateTotals();
            this.quantity.focus();
          }
        }
      }, options);
      this.form.addEventListener('submit', event => {
        if (event.target !== this.form) return;
        this.updateTotals();
        if (!this.validQuantity() || !this.variant?.available || this.productForm.classList.contains('m-spinner-loading')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.validQuantity()) this.quantity.reportValidity();
        }
      }, { ...options, capture: true });
      this.observer = new MutationObserver(() => this.updateTotals());
      this.observer.observe(this.productForm, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('product-ajax:added', () => { this.refreshCart(); this.refreshSpeculation(); }, options);
      document.addEventListener('cart:updated', event => { this.onCartUpdate(event.detail); this.refreshSpeculation(); }, options);
      ['cart-loaded', 'cart-updated'].forEach(type => window.addEventListener(`aftersell-upcart:public-events:${type}`, event => this.applyCart(event.detail?.cart?.items), options));
      window.addEventListener('popstate', () => {
        const id = Number(new URL(location.href).searchParams.get('variant'));
        const variant = this.config.variants.find(v => v.id === id);
        if (variant) { this.selection = [...variant.options]; this.selectVariant(false); }
      }, options);
      this.selectVariant(false);
      this.updateArea();
      this.observeBuybox();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.buyboxObserver?.disconnect();
      document.documentElement.classList.remove('egv3-sticky-bar');
    }
    label(key, values = {}) {
      return Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`{${name}}`, String(value)), this.config.labels[key] || key);
    }
    money(cents) {
      return new Intl.NumberFormat(this.config.locale || 'en-GB', { style: 'currency', currency: this.config.currency || 'GBP' }).format(cents / 100);
    }
    match(selection) {
      return this.config.variants.find(v => v.options.every((value, index) => value === selection[index]));
    }
    selectVariant(updateUrl) {
      this.variant = this.match(this.selection);
      this.variantInput.value = this.variant ? String(this.variant.id) : '';
      this.querySelectorAll('[data-option-index]').forEach(group => {
        const index = Number(group.dataset.optionIndex);
        group.querySelector('[data-option-label]').textContent = this.selection[index];
        group.querySelectorAll('input[type="radio"]').forEach(input => {
          input.checked = input.value === this.selection[index];
          if (index === this.config.finishIndex) return;
          const candidate = [...this.selection];
          candidate[index] = input.value;
          const variant = this.match(candidate);
          input.closest('label').classList.toggle('egf-unavailable', !variant?.available);
          input.closest('label').querySelector('[data-option-stock]').textContent = variant?.available ? '' : this.label(variant ? 'sold_out' : 'unavailable');
        });
      });
      this.querySelector('[data-unit-price]').textContent = this.variant ? this.money(this.variant.price) : '—';
      const business = this.querySelector('[data-unit-business-price]');
      if (business) {
        const exVat = Math.round((this.variant?.price || 0) / 1.2);
        business.textContent = this.variant ? this.label('business_price', { ex: this.money(exVat) }) : '';
      }
      const compareAtPrice = this.variant?.compareAtPrice;
      const hasCompareAtPrice = compareAtPrice > this.variant?.price;
      this.querySelector('[data-unit-compare-wrap]').hidden = !hasCompareAtPrice;
      this.querySelector('[data-unit-compare]').textContent = hasCompareAtPrice ? this.money(compareAtPrice) : '';
      const thickness = this.selection[this.config.thicknessIndex];
      this.querySelectorAll('[data-finish-link]').forEach(link => {
        const matching = this.config.finishLinks?.[link.dataset.finishLink]?.find(variant => variant.thickness === thickness);
        link.href = matching?.url || link.dataset.finishBaseUrl;
      });
      const guidance = this.config.guides.find(g => g.value === thickness);
      this.querySelector('[data-use]').textContent = guidance?.use || thickness;
      this.querySelector('[data-fitting]').textContent = parseFloat(thickness) >= 20 ? this.config.connectorText : this.config.flatText;
      this.dataset.finish = this.config.finishIndex >= 0 ? (/fleck/i.test(this.selection[this.config.finishIndex]) ? 'fleck' : 'black') : this.config.initialFinish;
      this.updateGallery();
      const { min, max, step } = this.rules();
      this.quantity.min = min;
      this.quantity.step = step;
      if (max === null || max < min) this.quantity.removeAttribute('max'); else this.quantity.max = max;
      this.querySelectorAll('[data-guide]').forEach(card => {
        const candidate = [...this.selection];
        candidate[this.config.thicknessIndex] = card.dataset.guide;
        const linked = this.match(candidate) ? null : this.config.finishLinks?.[this.dataset.finish]?.find(link => link.thickness === card.dataset.guide && Number.isFinite(link.price));
        const variant = this.match(candidate) || linked;
        const selected = card.dataset.guide === thickness;
        card.setAttribute('aria-pressed', String(selected));
        card.disabled = !variant;
        if (linked) card.dataset.guideUrl = linked.url; else delete card.dataset.guideUrl;
        card.querySelector('[data-guide-price]').textContent = variant ? `${this.money(variant.price)} / m²` : this.label('unavailable');
        const status = card.querySelector('[data-guide-status]');
        status.textContent = !variant?.available ? this.label(variant ? 'sold_out' : 'unavailable') : card.dataset.guideDrop || this.label(selected ? 'selected' : 'tile_equals');
        status.dataset.available = String(Boolean(variant?.available));
      });
      this.updateTotals();
      if (updateUrl && this.config.updateUrl && this.variant) {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.variant.id);
        history.replaceState(history.state, '', url);
      }
      const detail = { variant: this.variant, thickness, finish: this.dataset.finish, productSection: this.id };
      document.dispatchEvent(new CustomEvent('flooring:change', { detail }));
      this.updateSpecifications(detail);
    }
    updateSpecifications({ thickness, finish, variant }) {
      const values = { thickness, finish: this.label(finish === 'fleck' ? 'white_fleck' : 'plain_black'), connectors: this.label(parseFloat(thickness) >= 20 ? 'connector_yes' : 'connector_no'), variant: variant ? variant.options.join(' / ') : this.label('unavailable') };
      document.querySelectorAll('[data-flooring-spec]').forEach(node => node.textContent = values[node.dataset.flooringSpec] || '');
      document.querySelectorAll('[data-spec-thickness]').forEach(node => node.hidden = node.dataset.specThickness !== thickness);
      document.querySelectorAll('[data-material-finish]').forEach(node => node.hidden = node.dataset.materialFinish !== finish);
    }
    rules() {
      const variant = this.variant;
      const min = variant?.rules?.min || 1;
      const step = variant?.rules?.increment || 1;
      const cart = variant?.cartQuantity || 0;
      const caps = [variant?.rules?.max, variant?.inventory].filter(value => value !== null && value !== undefined).map(value => Math.max(0, value - cart));
      const max = caps.length ? Math.min(...caps) : null;
      // Tiles still orderable from tracked stock once the basket is counted; null when stock does not limit the order.
      const stock = variant?.inventory === null || variant?.inventory === undefined ? null : Math.max(0, variant.inventory - cart);
      return { min, step, max, stock, cart, stockLimited: stock !== null && max === stock };
    }
    quantityMessage() {
      const { min, max, step, stock, cart, stockLimited } = this.rules();
      const value = Number(this.quantity.value);
      // Stock-limited messages end with a contact link, so customers who need more know who to ask.
      if (stockLimited && (max < min ? cart > 0 : value > max)) this.contactPrompt = 'stock';
      if (max !== null && max < min) return stockLimited && cart > 0 ? this.label('stock_in_basket', { count: this.variant.inventory }) : this.label('no_stock_quantity');
      if (stockLimited && value > max) return this.label(cart > 0 ? 'stock_limit_cart' : 'stock_limit', { count: this.variant.inventory, cart, max: stock });
      if (step === 1) return this.label(max === null ? 'quantity_minimum' : 'quantity_range', { min, max });
      return this.label(max === null ? 'quantity_no_max' : 'quantity_invalid', { min, max, step });
    }
    // Plain-text version of the contact line, for the input's validation message.
    promptText() {
      return this.contactPrompt ? this.label(`${this.contactPrompt}_prompt`, { link: this.label(`${this.contactPrompt}_contact`) }) : '';
    }
    // Writes the message, then the contact line on its own line. The link opens the Commslayer chat (eg-v3-purchase-trust); the contact page is the fallback.
    showQuantityError(node, message) {
      node.textContent = message;
      if (!this.contactPrompt || !this.config.contactUrl) return;
      const link = document.createElement('a');
      link.href = this.config.contactUrl;
      link.dataset.openChat = '';
      link.textContent = this.label(`${this.contactPrompt}_contact`);
      const [before, after = ''] = this.label(`${this.contactPrompt}_prompt`).split('{link}');
      const more = document.createElement('span');
      more.className = 'egf-error-more';
      more.append(` ${before}`, link, after);
      node.append(more);
    }
    updateStock() {
      const variant = this.variant;
      const { min, max, stock: remaining } = this.rules();
      const available = Boolean(variant?.available && (max === null || max >= min));
      const low = available && this.config.lowStockAt > 0 && remaining !== null && remaining > 0 && remaining <= this.config.lowStockAt;
      const stock = this.querySelector('[data-stock]');
      stock.textContent = low ? this.label('low_stock', { count: remaining }) : this.label(available ? 'in_stock' : variant ? 'sold_out' : 'unavailable');
      stock.dataset.available = String(available);
      stock.dataset.stockState = !available ? 'sold_out' : low ? 'low' : 'in_stock';
    }
    validQuantity() {
      const value = Number(this.quantity.value);
      const { min, max, step } = this.rules();
      return this.quantity.value.trim() !== '' && Number.isSafeInteger(value) && value >= min && (max === null || value <= max) && (value - min) % step === 0;
    }
    priceFor(quantity) {
      const variant = this.variant;
      let price = variant?.price || 0;
      const breaks = variant?.breaks || [];
      const pricingQuantity = quantity + (variant?.cartQuantity || 0);
      [...breaks].sort((a, b) => a.minimum_quantity - b.minimum_quantity).forEach(tier => { if (pricingQuantity >= tier.minimum_quantity) price = tier.price; });
      const percent = this.config.volume && breaks.length === 0 ? [[10, 5], [25, 10], [50, 15], [100, 20], [200, 25]].reduce((discount, [threshold, value]) => quantity >= threshold ? value : discount, 0) : 0;
      const unitDiscount = Math.floor(price * percent / 100);
      return { price, percent, total: (price - unitDiscount) * quantity };
    }
    // The fewest extra tiles that take the order (with the basket) to free delivery.
    tilesToFreeDelivery(estimate, quantity) {
      const freeFrom = Number(estimate.dataset.freeFrom), basketTotal = Number(estimate.dataset.basketTotal) || 0;
      const { max, step } = this.rules();
      if (!(freeFrom > 0) || basketTotal + this.priceFor(quantity).total >= freeFrom) return 0;
      for (let extra = step; extra <= 60; extra += step) {
        if (max !== null && quantity + extra > max) return 0;
        if (basketTotal + this.priceFor(quantity + extra).total >= freeFrom) return extra;
      }
      return 0;
    }
    updateTotals() {
      const valid = this.validQuantity();
      const { min, max, step } = this.rules();
      const quantityInvalid = Boolean(this.variant?.available) && !valid;
      const soldOut = Boolean(this.variant) && !this.variant.available;
      this.contactPrompt = soldOut ? 'back' : null;
      // Reaching the stock limit (the + button stops) explains why, before the customer types a bigger number.
      const limit = this.rules();
      const atStockLimit = !soldOut && valid && limit.stockLimited && limit.max >= limit.min && Number(this.quantity.value) === limit.max;
      if (atStockLimit) this.contactPrompt = 'stock';
      const message = soldOut ? this.label('sold_out_message') : atStockLimit ? this.label(limit.cart > 0 ? 'stock_limit_cart' : 'stock_limit', { count: this.variant.inventory, cart: limit.cart, max: limit.stock }) : quantityInvalid ? this.quantityMessage() : '';
      this.updateStock();
      this.quantity.setCustomValidity(quantityInvalid ? [message, this.promptText()].filter(Boolean).join(' ') : '');
      this.quantity.setAttribute('aria-invalid', String(quantityInvalid));
      this.showQuantityError(this.querySelector('[data-quantity-error]'), message);
      const quantity = Number(this.quantity.value);
      const variant = this.variant;
      const breaks = variant?.breaks || [];
      const { price, percent, total } = this.priceFor(quantity);
      const totalText = valid && variant ? this.money(total) : '—';
      this.querySelector('[data-total]').textContent = totalText;
      const hasCompareAtPrice = variant?.compareAtPrice > variant?.price;
      const compareTotal = (hasCompareAtPrice ? variant.compareAtPrice : variant?.price || 0) * quantity;
      const showCompareTotal = valid && variant && compareTotal > total;
      this.querySelector('[data-total-compare-wrap]').hidden = !showCompareTotal;
      this.querySelector('[data-total-compare]').textContent = showCompareTotal ? this.money(compareTotal) : '';
      this.querySelector('[data-total-compare-label]').textContent = this.label(hasCompareAtPrice ? 'regular_total' : 'before_volume');
      this.querySelector('[data-coverage]').textContent = valid ? `${quantity} m²` : '—';
      const saving = this.querySelector('[data-saving]');
      if (saving) saving.textContent = !valid ? '' : percent ? this.label('saving', { percent, amount: this.money(price * quantity - total) }) : breaks.length && price < variant.price ? this.label('break_saving') : this.config.volumeHint;
      const busy = this.productForm.classList.contains('m-spinner-loading');
      this.submitButton.disabled = !valid || !variant?.available || busy;
      this.submitButton.setAttribute('aria-busy', String(busy));
      this.querySelector('[data-submit-text]').textContent = busy && this.submitButton.dataset.loadingLabel ? this.submitButton.dataset.loadingLabel : this.label(variant?.available ? 'add_to_basket' : variant ? 'sold_out' : 'unavailable');
      this.querySelectorAll('[data-quantity-step]').forEach(button => { button.disabled = busy || !variant?.available || (Number(button.dataset.quantityStep) < 0 ? quantity <= min : max !== null && quantity + step > max); });
      const estimate = this.querySelector('eg-delivery-estimate');
      if (estimate) {
        const ready = Boolean(valid && variant?.available);
        const extra = ready ? this.tilesToFreeDelivery(estimate, quantity) : 0;
        Object.assign(estimate.dataset, { weight: String(ready ? (variant.weight || 0) * quantity : 0), total: String(ready ? total : 0), available: String(ready), inStock: String(variant?.inventory === null || variant?.inventory > 0), moreHint: extra ? this.label(extra === 1 ? 'tiles_to_free_one' : 'tiles_to_free', { count: extra }) : '' });
      }
      const mobileTotal = this.querySelector('[data-mobile-total]');
      if (mobileTotal) {
        mobileTotal.textContent = totalText;
        this.querySelector('[data-mobile-selection]').textContent = this.selection.join(' · ');
      }
    }
    areaEstimate() {
      const length = Number(this.querySelector('[data-area="length"]').value);
      const width = Number(this.querySelector('[data-area="width"]').value);
      if (![length, width].every(value => Number.isFinite(value) && value > 0 && value <= 100)) return null;
      const area = length * width;
      const allowance = this.querySelector('[data-waste]').checked;
      return { area, allowance, tiles: Math.ceil(area * (allowance ? 1.1 : 1) - 1e-9) };
    }
    updateArea() {
      const estimate = this.areaEstimate();
      const result = this.querySelector('[data-area-result]');
      result.querySelector('[data-area-tiles]').textContent = estimate ? this.label('area_result_tiles', { tiles: estimate.tiles }) : '';
      result.querySelector('[data-area-detail]').textContent = estimate ? this.label('area_result_area', { area: new Intl.NumberFormat(this.config.locale, { maximumFractionDigits: 2 }).format(estimate.area), allowance: estimate.allowance ? this.label('area_allowance') : '' }) : this.label('area_invalid');
      result.classList.toggle('is-invalid', !estimate);
      this.querySelector('[data-apply-area]').disabled = !estimate;
    }
    stepGallery(direction) {
      const group = this.querySelector('[data-gallery-finish]:not([hidden])');
      const views = [...(group?.querySelectorAll('[data-gallery]') || [])].map(button => button.dataset.gallery);
      if (views.length < 2) return;
      this.gallery = views[(Math.max(0, views.indexOf(this.gallery)) + direction + views.length) % views.length];
      this.updateGallery();
    }
    // Arrow keys on the gallery controls, and a sideways swipe on the image.
    initGalleryGestures(options) {
      const gallery = this.querySelector('.egf-gallery');
      if (!gallery) return;
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const onThumb = event.target.closest('[data-gallery]');
        if (!onThumb && !event.target.closest('[data-gallery-step]')) return;
        event.preventDefault();
        this.stepGallery(event.key === 'ArrowRight' ? 1 : -1);
        if (onThumb) gallery.querySelector('[data-gallery-finish]:not([hidden]) [data-gallery][aria-pressed="true"]')?.focus();
      }, options);
      let start = null;
      gallery.addEventListener('touchstart', event => {
        start = event.touches.length === 1 && event.target.closest('.egf-gallery-stage') ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { ...options, passive: true });
      gallery.addEventListener('touchend', event => {
        if (!start) return;
        const x = event.changedTouches[0].clientX - start.x, y = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y) * 1.5) this.stepGallery(x < 0 ? 1 : -1);
      }, { ...options, passive: true });
    }
    updateGallery() {
      this.querySelectorAll('[data-gallery-finish]').forEach(group => {
        group.hidden = group.dataset.galleryFinish !== this.dataset.finish;
        group.querySelectorAll('[data-panel]').forEach(panel => panel.hidden = panel.dataset.panel !== this.gallery);
        group.querySelectorAll('[data-gallery]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gallery === this.gallery)));
      });
    }
    observeBuybox() {
      const summary = this.querySelector('.egf-mobile-summary');
      if (!summary || !('IntersectionObserver' in window)) return;
      this.buyboxObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        summary.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        document.documentElement.classList.toggle('egv3-sticky-bar', !summary.hidden && getComputedStyle(summary).display !== 'none');
      });
      this.buyboxObserver.observe(this.querySelector('.egf-buybox'));
    }
    // A page fetched in the background before the basket changed would show the old basket, so fetch it again.
    refreshSpeculation() {
      const rules = this.querySelector('[data-flooring-speculation]');
      if (!rules) return;
      const fresh = document.createElement('script');
      fresh.type = 'speculationrules';
      fresh.dataset.flooringSpeculation = '';
      fresh.textContent = rules.textContent;
      rules.replaceWith(fresh);
    }
    onCartUpdate(payload) {
      const cart = payload?.cart || payload;
      if (Array.isArray(cart?.items) && Number.isFinite(cart.item_count)) this.applyCart(cart.items);
      else if (!cart?.sections || (!cart.id && !Array.isArray(cart.items))) this.refreshCart();
    }
    applyCart(items) {
      if (!Array.isArray(items)) return;
      this.cartRevision = (this.cartRevision || 0) + 1;
      this.config.variants.forEach(variant => variant.cartQuantity = items.filter(item => Number(item.variant_id || item.variantId) === variant.id).reduce((sum, item) => sum + item.quantity, 0));
      this.selectVariant(false);
    }
    async refreshCart() {
      const revision = this.cartRevision || 0;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, signal: this.controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (revision === (this.cartRevision || 0) && this.isConnected) this.applyCart(cart.items);
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('Flooring quantities will be checked by Shopify at checkout.');
      }
    }
  });
}

// A material feature further down the page can open one of the gallery photos (for example the texture close-up).
document.addEventListener('click', event => {
  const jump = event.target.closest('[data-gallery-jump]');
  if (!jump) return;
  const group = document.querySelector('flooring-choice [data-gallery-finish]:not([hidden])');
  const thumb = group?.querySelector(`[data-gallery="${jump.dataset.galleryJump}"]`);
  if (!thumb) return;
  thumb.click();
  group.querySelector('.egf-gallery-stage')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

  } catch(e) { console.error(e); }
})();
})();
